export default values => ({
  name: values ? values.name : '',
  role: values ? values.role : '',
  officePhone: values ? values.officePhone : '',
  phone: values ? values.phone : '',
  email: values ? values.email : '',
});
